import UrlPattern from "url-pattern";

const COURSE_BASE = "/courses/:courseId";
export const courseBaseUrl = new UrlPattern("/courses/:courseId(/*)");

export const newBaseUrl = new UrlPattern("/courses/:courseId/:editPageType/new")
export const editBaseUrl = new UrlPattern('/courses/:courseId/:editPageType/:itemId/edit')

// INTERFACE URLS //
const BADGE_RESOURCE_URL = `${COURSE_BASE}/badges/:badgeId`;
export const BADGE_URLS = {
  index: new UrlPattern(`${COURSE_BASE}/badges`),
  create: new UrlPattern(`${COURSE_BASE}/badges/new`),
  resource: new UrlPattern(BADGE_RESOURCE_URL),
  edit: new UrlPattern(`${BADGE_RESOURCE_URL}/edit`),
  quickAward: new UrlPattern(`${BADGE_RESOURCE_URL}/earned_badges/mass_edit`),
  award: new UrlPattern(`${BADGE_RESOURCE_URL}/earned_badges/new`),
};

// Admin Overview
export const overviewUrl = new UrlPattern("/overview");
export const overviewCoursesUrl = new UrlPattern("/overview/courses");
export const overviewUsersUrl = new UrlPattern("/overview/users");
export const overviewUsersResourceUrl = new UrlPattern("/overview/users/:userId");
export const overviewSubscriptionsUrl = new UrlPattern("/overview/subscriptions");
export const overviewInstitutionsUrl = new UrlPattern("/overview/institutions");

// Overview
export const courseDashboardUrl = new UrlPattern(`${COURSE_BASE}/dashboard`);
export const courseGradingStatusUrl = new UrlPattern(`${COURSE_BASE}/grading_status`);
export const courseAnnouncementListUrl = new UrlPattern(`${COURSE_BASE}/announcements`);
export const courseAnnouncementDetailUrl = new UrlPattern(`${COURSE_BASE}/announcements/:announcementId`);
export const courseEventsUrl = new UrlPattern(`${COURSE_BASE}/events`);

// Analytics Urls
export const courseAnalyticsStudentsUrl = new UrlPattern(`${COURSE_BASE}/analytics/students`);
export const courseAnalyticsAssignmentsUrl = new UrlPattern(`${COURSE_BASE}/analytics`);
export const courseAnalyticsAssignmentTypesUrl = new UrlPattern(`${COURSE_BASE}/analytics/assignment_types`);
export const courseAnalyticsExportDataUrl = new UrlPattern(`${COURSE_BASE}/assignments/:assignmentId/grades/export.csv`);

export const analyticsUrls = {
  assignments: courseAnalyticsAssignmentsUrl,
  students: courseAnalyticsStudentsUrl,
  assignmentTypes: courseAnalyticsAssignmentTypesUrl,
};
export const courseDataExportsUrl = new UrlPattern(`${COURSE_BASE}/downloads`);

// Export Urls
export const courseExportEarnedBadgesUrl = new UrlPattern(`${COURSE_BASE}/export_earned_badges.csv`);
export const courseExportResearchGradebookUrl = new UrlPattern(`${COURSE_BASE}/research_gradebook.csv`);
export const courseExportFinalGradesUrl = new UrlPattern(`${COURSE_BASE}/final_grades.csv`);
export const courseExportAssignmentStructureUrl = new UrlPattern(`${COURSE_BASE}/assignment_structure_export.csv`);
export const courseExportSubmissionsUrl = new UrlPattern(`${COURSE_BASE}/submissions.csv`);
export const courseExportAssignmentTypeSummaryUrl = new UrlPattern(`${COURSE_BASE}/assignment_types/export_all_scores.csv`);
export const courseExportGradebookFileUrl = new UrlPattern(`${COURSE_BASE}/gradebook_file.csv`);
export const courseExportMultipliedGradebookUrl = new UrlPattern(`${COURSE_BASE}/multiplied_gradebook.csv`);
export const courseExportBadgeStructureUrl = new UrlPattern(`${COURSE_BASE}/badges/export_structure.csv`);
export const courseExportGradeSchemeStructureUrl = new UrlPattern(`${COURSE_BASE}/grade_scheme_elements/export_structure.csv`);

export const courseExportUrls = {
  earnedBadges: courseExportEarnedBadgesUrl,
  researchGradebook: courseExportResearchGradebookUrl,
  finalGrades: courseExportFinalGradesUrl,
  assignmentStructure: courseExportAssignmentStructureUrl,
  submissions: courseExportSubmissionsUrl,
  assignmentTypeSummary: courseExportAssignmentTypeSummaryUrl,
  gradebookFile: courseExportGradebookFileUrl,
  multipliedGradebook: courseExportMultipliedGradebookUrl,
  badgeStructure: courseExportBadgeStructureUrl,
  gradeSchemeStructure: courseExportGradeSchemeStructureUrl,
};

// Setup
export const courseEditUrl = new UrlPattern(`${COURSE_BASE}/edit`); // General settings
export const courseChallengesUrl = new UrlPattern(`${COURSE_BASE}/challenges`);
export const courseChallengeDetailsUrl = new UrlPattern(`${COURSE_BASE}/challenges/:challengeId`);

export const courseGradeSchemeElementsUrl = new UrlPattern(`${COURSE_BASE}/grade_scheme_elements`)
export const setLockConditionsUrl = new UrlPattern(`${COURSE_BASE}/grade_scheme_elements/:elementId/edit`);

// Users
export const courseStudentsUrl = new UrlPattern(`${COURSE_BASE}/students`);
export const courseStudentDetailUrl = new UrlPattern(`${COURSE_BASE}/students/:studentId`);

export const courseTeamsUrl = new UrlPattern(`${COURSE_BASE}/teams`);
export const courseGroupsUrl = new UrlPattern(`${COURSE_BASE}/groups`); //has counter
export const courseGroupDetailUrl = new UrlPattern(`${COURSE_BASE}/groups/:groupId`);
export const courseGroupEditUrl = new UrlPattern(`${COURSE_BASE}/groups/:groupId/edit`);
export const courseStaffUrl = new UrlPattern(`${COURSE_BASE}/staff`);
export const courseStaffDetailUrl = new UrlPattern(`${COURSE_BASE}/staff/:staffId`);

export const courseObserversUrl = new UrlPattern(`${COURSE_BASE}/observers`);

// Coursework
export const courseGradebookUrl = new UrlPattern(`${COURSE_BASE}/gradebook`);
export const courseAttendanceUrl = new UrlPattern(`${COURSE_BASE}/attendance`); // automatically redirects to setup if none
export const courseAttendanceSetupUrl = new UrlPattern(`${COURSE_BASE}/attendance/setup`);
export const courseMultiplierChoicesUrl = new UrlPattern(`${COURSE_BASE}/multiplier_choices`);
export const coursePredictorUrl = new UrlPattern(`${COURSE_BASE}/predictor`);
export const courseEarnedBadgesUrl = new UrlPattern(`${COURSE_BASE}/earned_badges`);

// Assignments
export const courseAssignmentsDetailsBaseUrl = new UrlPattern(`${COURSE_BASE}/assignments/:assignmentId(/*)`);
export const courseSubmissionDetailUrl = new UrlPattern(`${COURSE_BASE}/assignments/:assignmentId/submissions/:submissionId`);
export const courseSubmissionsExportUrl = new UrlPattern(`${COURSE_BASE}/submissions_exports`);
export const courseAssignmentGradesExportUrl = new UrlPattern(`${COURSE_BASE}/assignments/:assignmentId/grades/export.csv`);
export const courseAssignmentExportEarnedLevelsUrl = new UrlPattern(`${COURSE_BASE}/assignments/:assignmentId/grades/export_earned_levels.csv`);
export const courseAssignmentRubricExportUrl = new UrlPattern(`${COURSE_BASE}/assignments/:assignmentId/rubrics/export.csv`);
export const googleCalendarAssignmentUrl = new UrlPattern("/google_calendars/assignments/assignment/:assignmentId");

const ASSIGNMENTS_RESOURCE_URL = `${COURSE_BASE}/assignments/:assignmentId`;
export const ASSIGNMENT_URLS = {
  index: new UrlPattern(`${COURSE_BASE}/assignments`),
  resource: new UrlPattern(ASSIGNMENTS_RESOURCE_URL),
  edit: new UrlPattern(`${ASSIGNMENTS_RESOURCE_URL}/edit`),
  settings: new UrlPattern(`${COURSE_BASE}/assignments/settings`),
  quickGrade: new UrlPattern(`${ASSIGNMENTS_RESOURCE_URL}/grades/quick_grade`),
  quickGradeGroups: new UrlPattern(`${ASSIGNMENTS_RESOURCE_URL}/groups/grades/mass_edit`)
}

// Assignment Type
export const ASSIGNMENT_TYPE_URLS = {
  resource: new UrlPattern(`${COURSE_BASE}/assignment_types/:assignmentTypeId`),
  edit: new UrlPattern(`${COURSE_BASE}/assignment_types/:assignmentTypeId/edit`)
}
// Unlock States
export const courseUnlockStateManuallyUnlockUrl = new UrlPattern(`${COURSE_BASE}/unlock_states/:unlockStateId/manually_unlock`);

// Grades
export const courseGradeDetailUrl = new UrlPattern(`${COURSE_BASE}/grades/:gradeId`);
export const courseGradeCreateUrl = new UrlPattern(`${COURSE_BASE}/assignments/:assignmentId/students/:studentId/grade`);
export const courseGroupGradeCreateUrl = new UrlPattern(`${COURSE_BASE}/assignments/:assignmentId/groups/:groupId/grade`);
export const courseGroupGradeDeleteAllUrl = new UrlPattern(`${COURSE_BASE}/assignments/:assignmentId/groups/grades/delete_all`);
export const courseGradeEditUrl = new UrlPattern(`${COURSE_BASE}/grades/:gradeId/edit`);

// Admin (as seen in old sidebar)
export const courseMembershipsUrl = new UrlPattern(`${COURSE_BASE}/course_memberships`);
export const courseUsersUrl = new UrlPattern(`${COURSE_BASE}/users`);
export const courseAdminToolsUrl = new UrlPattern(`${COURSE_BASE}/admin/tools`);
export const courseJobsUrl = new UrlPattern(`${COURSE_BASE}/jobs`);
export const courseJobsDetailUrl = new UrlPattern(`${COURSE_BASE}/jobs/:jobId`);
export const ltiKeysUrl = new UrlPattern("/overview/lti_keys");
export const ltiPlatformInstancesUrl = new UrlPattern("/overview/lti_platform_instances");
export const ltiRegistrationsUrl = new UrlPattern("/overview/lti_registrations");
export const ltiDeploymentsUrl = new UrlPattern("/overview/lti_deployments");
export const ltiContextsUrl = new UrlPattern("/overview/lti_contexts");

// Other
export const courseSyllabusUrl = new UrlPattern(`${COURSE_BASE}/syllabus`);
export const editUserProfileUrl = new UrlPattern("/users/edit_profile");
export const logoutUrl = new UrlPattern("/logout");
export const exitImpersonateUrl = new UrlPattern("/exit_student_impersonation");
export const userImportOptionsUrl = new UrlPattern(`${COURSE_BASE}/users/importers`);
export const courseUsersNewUrl = new UrlPattern(`${COURSE_BASE}/users/new`);
export const courseTeamsDetailUrl = new UrlPattern("/courses/:courseId/teams/:teamId");

export const LEARNING_OBJECTIVE_URLS = {
  indexStaff: new UrlPattern(`${COURSE_BASE}/learning_objectives/objectives`),
  indexStudent: new UrlPattern(`${COURSE_BASE}/learning_objectives/links`),
  create: new UrlPattern(`${COURSE_BASE}/learning_objectives/objectives/new`),
  resource: new UrlPattern(`${COURSE_BASE}/learning_objectives/objectives/:learningObjectiveId`),
  edit: new UrlPattern(`${COURSE_BASE}/learning_objectives/objectives/:learningObjectiveId/edit`),
  categoryCreate: new UrlPattern(`${COURSE_BASE}/learning_objectives/categories/new`),
  categoryEdit: new UrlPattern(`${COURSE_BASE}/learning_objectives/categories/:learningObjectiveCategoryId/edit`),
}

// API URLS //

// Top Level Dashboard V2
export const INSTITUTIONS_API_V2_URLS = {
  index: new UrlPattern("/api/v2/admin/institutions"),
  resource: new UrlPattern("/api/v2/admin/institutions/:institutionId"),
}
// V0: api/something
const API_V1_BASE = "/api/courses/:courseId";
const API_V2_ADMIN_BASE = "/api/v2/admin/courses/:courseId"
const API_V2_STUDENT_BASE = "/api/v2/students/courses/:courseId"

export const courseSearchAPIUrl = new UrlPattern("/api/courses/search");
export const studentSearchAPIUrl = new UrlPattern("/api/students");
export const changeGuideAPIUrl = new UrlPattern("/api/users/change_guide");

export const assignmentTypeListAPIUrl = new UrlPattern("/api/assignment_types");

export const unlockConditionsCreateAPIUrl = new UrlPattern("/api/unlock_conditions");
export const unlockConditionsAPIUrl = new UrlPattern("/api/unlock_conditions/:unlockId");
export const unlockConditionsListAPIUrl = new UrlPattern("/api/:unlockableType/:unlockableId/unlock_conditions");
export const keysListAPIUrl = new UrlPattern("/api/:conditionType/:conditionId/unlock_conditions/keys");

export const unlocksAPIUrls = {
  list: unlockConditionsListAPIUrl,
  keysList: keysListAPIUrl,
  create: unlockConditionsCreateAPIUrl,
  update: unlockConditionsAPIUrl,
  delete: unlockConditionsAPIUrl,
}

export const coursePointsPlannerAssignmentTypeListAPIUrl = new UrlPattern("/api/courses/:courseId/points_planner/assignment_types");
export const coursePointsPlannerAssignmentTypeWeightAPIUrl = new UrlPattern("/api/courses/:courseId/points_planner/assignment_type_weights");
export const coursePointsPlannerAssignmentTypeWeightDetailAPIUrl = new UrlPattern("/api/courses/:courseId/points_planner/assignment_type_weights/:assignmentTypeWeightId");
export const coursePointsPlannerPredictedEarnedGradeAPIUrl = new UrlPattern("/api/courses/:courseId/points_planner/predicted_earned_grades");
export const coursePointsPlannerPredictedEarnedGradeDetailAPIUrl = new UrlPattern("/api/courses/:courseId/points_planner/predicted_earned_grades/:predictedEarnedGradeId");
export const coursePointsPlannerChallengeListAPIUrl = new UrlPattern("/api/courses/:courseId/points_planner/challenges");
export const coursePointsPlannerPredictedEarnedChallengeAPIUrl = new UrlPattern("/api/courses/:courseId/points_planner/challenges/predicted_earned_challenges");
export const coursePointsPlannerPredictedEarnedChallengeDetailAPIUrl = new UrlPattern("/api/courses/:courseId/points_planner/challenges/predicted_earned_challenges/:predictedEarnedChallengeId");

export const coursePointsPlannerAPIUrls = {
  assignmentTypeList: coursePointsPlannerAssignmentTypeListAPIUrl,
  assignmentTypeWeightCreate: coursePointsPlannerAssignmentTypeWeightAPIUrl,
  assignmentTypeWeightDetail: coursePointsPlannerAssignmentTypeWeightDetailAPIUrl,
  badgeList: new UrlPattern(`${API_V2_STUDENT_BASE}/badges/points_planner`),
  challengeList: coursePointsPlannerChallengeListAPIUrl,
  predictedEarnedBadgeCreate: new UrlPattern(`${API_V2_STUDENT_BASE}/predicted_earned_badges`),
  predictedEarnedBadgeDetail: new UrlPattern(`${API_V2_STUDENT_BASE}/predicted_earned_badges/:predictedEarnedBadgeId`),
  predictedEarnedGradeCreate: coursePointsPlannerPredictedEarnedGradeAPIUrl,
  predictedEarnedGradeDetail: coursePointsPlannerPredictedEarnedGradeDetailAPIUrl,
  predictedEarnedChallengeCreate: coursePointsPlannerPredictedEarnedChallengeAPIUrl,
  predictedEarnedChallengeDetail: coursePointsPlannerPredictedEarnedChallengeDetailAPIUrl,
};

export const ckEditorAPIURLs = {
  upload: "/api/upload_wysiwyg_images",
  view: "/api/download_wysiwyg_object/",
  delete: "/api/delete_wysiwyg_images",
};

export const courseCreationUrl = new UrlPattern("/api/course_creation");
export const getAnnouncementsCurrentUserUrl = new UrlPattern("/api/courses/:courseId/announcements/for_current_user");
export const getCurrentCourseUrl = new UrlPattern("/api/courses/:courseId");
export const getHeaderDataUrl = new UrlPattern("/api/courses/:courseId/header_data");
export const getNavigationCountsUrl = new UrlPattern("/api/courses/:courseId/navigation_counts");
export const activateAllStudentsUrl = new UrlPattern("/api/courses/:courseId/activate_all_students");
export const getCurrentUserURL = new UrlPattern("/api/users/current");

export const courseAnalyticsStudentsAPIUrl = new UrlPattern("/api/courses/:courseId/analytics/students");
export const courseAnalyticsAssignmentsAPIUrl = new UrlPattern("/api/courses/:courseId/analytics/assignments");
export const courseAnalyticsAssignmentTypesAPIUrl = new UrlPattern("/api/courses/:courseId/analytics/assignment_types");
export const courseAnalyticsAssignmentTypesStudentsAPIUrl = new UrlPattern("/api/courses/:courseId/analytics/assignment_types_students");
export const courseAnalyticsAPIUrls = {
  assignments: courseAnalyticsAssignmentsAPIUrl,
  assignmentTypes: courseAnalyticsAssignmentTypesAPIUrl,
  assignmentTypesStudents: courseAnalyticsAssignmentTypesStudentsAPIUrl,
  students: courseAnalyticsStudentsAPIUrl,
};

export const dashboardBadges = new UrlPattern("/api/courses/:courseId/dashboard/visible_badges");
export const dashboardAssignmentsAllAPIUrl = new UrlPattern("/api/courses/:courseId/dashboard/assignments_by_status");
export const dashboardClassPointsAPIUrl = new UrlPattern("/api/courses/:courseId/dashboard/class_points");
export const dashboardGradeSchemeProgressAPIUrl = new UrlPattern("/api/courses/:courseId/dashboard/grade_scheme_progress");
export const dashboardMessageAPIUrl = new UrlPattern("/api/courses/:courseId/dashboard/message");
export const dashboardWeeklyStatsAPIUrl = new UrlPattern("/api/courses/weekly_stats");
export const dashboardTimelineAPIUrl = new UrlPattern("/api/timeline_events");
export const dashboardWeightsAPIUrl = new UrlPattern("/api/courses/:courseId/dashboard/weights");

export const courseDashboardAPIUrls = {
  analyticsPoints: dashboardClassPointsAPIUrl,
  weeklyStats: dashboardWeeklyStatsAPIUrl,
  assignmentsAll: dashboardAssignmentsAllAPIUrl,
  gradeSchemeProgress: dashboardGradeSchemeProgressAPIUrl,
  message: dashboardMessageAPIUrl,
  timeline: dashboardTimelineAPIUrl,
  weights: dashboardWeightsAPIUrl,
};

// assignment.js
export const gradeDeleteAPIUrl = new UrlPattern("/api/grades/:gradeId");
export const getAssignmentAPIUrl = new UrlPattern("/api/assignments/:assignmentId");
export const getAssignmentGradesUrl = new UrlPattern("/api/courses/:courseId/assignments/:assignmentId/grades/quick_grade");
export const putQuickGradesUrl = new UrlPattern("/api/courses/:courseId/assignments/:assignmentId/grades/quick_update");
export const postGroupMassEditUrl = new UrlPattern('/courses/:courseId/assignments/:assignmentId/groups/grades/mass_update')

// courses.js
export const courseAdminOverviewAPIUrl = new UrlPattern("/api/courses/admin_overview");
export const courseArchiveAPIUrl = new UrlPattern("/api/courses/archive");
export const courseUnarchiveAPIUrl = new UrlPattern("/api/courses/unarchive");
export const courseDeleteAPIUrl = new UrlPattern("/api/courses/:courseId");
export const coursePublishAPIUrl = new UrlPattern("/api/courses/publish");
export const courseUnpublishAPIUrl = new UrlPattern("/api/courses/unpublish");
export const dashboardAdminNewActivityAPIUrl = new UrlPattern("/api/dashboard/admin_new_activity");

// gradingStatus.js
export const getGradesSubsetUrl = (idArray) => `/api/grading_status/grades/batch_grades?grade_ids=${idArray.join(",")}`;
export const getInProgressIdsUrl = new UrlPattern("/api/grading_status/grades/in_progress_ids");
export const getReleaseReadyIdsUrl = new UrlPattern("/api/grading_status/grades/ready_for_release_ids");
export const getResubmissionIdsUrl = new UrlPattern("/api/grading_status/submissions/resubmitted_ids");
export const getSubmissionSubsetUrl = (idArray) => `/api/grading_status/submissions/batch_submissions?submission_ids=${idArray.join(",")}`;
export const getUngradedIdsUrl = new UrlPattern("/api/grading_status/submissions/ungraded_ids");

// users.js
export const adminOverviewSearchUsersUrl = new UrlPattern("/api/users/admin_overview_search");
export const getInstructorsUrl = new UrlPattern("/api/users/instructors");

// Canvas
export const getCanvasGradesUrl = new UrlPattern("/api/assignments/:assignmentId/grades/importers/:providerName/course/:providerCourseId");
export const importCanvasGradesAssignmentSelectUrl = new UrlPattern("/courses/:courseId/assignments/:assignmentId/grades/importers/:providerName/assignments")
export const importCanvasGradesSelectUrl = new UrlPattern("/courses/:courseId/assignments/:assignmentId/grades/importers/:providerName/courses/:providerCourseId/grades");
export const importCanvasGradesUrl = new UrlPattern("/courses/:courseId/assignments/:assignmentId/grades/importers/:providerName/courses/:providerCourseId/grades/import")

// API V2 URLS //

// Assignments
const ASSIGNMENTS_API_V2_ADMIN_BASE_URL = `${API_V2_ADMIN_BASE}/assignments`;
const ASSIGNMENTS_API_V2_RESOURCE_URL = `${ASSIGNMENTS_API_V2_ADMIN_BASE_URL}/:assignmentId`;
export const ASSIGNMENTS_API_V2_URLS = {
  index: new UrlPattern(ASSIGNMENTS_API_V2_ADMIN_BASE_URL),
  resource: new UrlPattern(ASSIGNMENTS_API_V2_RESOURCE_URL),
  uploads: new UrlPattern(`${ASSIGNMENTS_API_V2_RESOURCE_URL}/file_uploads`),
  fileRemoval: new UrlPattern(`${ASSIGNMENTS_API_V2_RESOURCE_URL}/file_removal`),
  options: new UrlPattern(`${ASSIGNMENTS_API_V2_ADMIN_BASE_URL}/options`),
  students: new UrlPattern(`${ASSIGNMENTS_API_V2_RESOURCE_URL}/students`),
  groups: new UrlPattern(`${ASSIGNMENTS_API_V2_RESOURCE_URL}/groups/grades`),
  deleteAllAttendance: new UrlPattern("/api/attendance/delete_all"),
  deleteAllGrades: new UrlPattern(`${ASSIGNMENTS_API_V2_RESOURCE_URL}/delete_all_grades`),
  releaseGrades: new UrlPattern(`${ASSIGNMENTS_API_V2_RESOURCE_URL}/release_grades`),
  analytics: new UrlPattern(`${ASSIGNMENTS_API_V2_RESOURCE_URL}/analytics`),
}

export const ASSIGNMENT_TYPES_API_V2_URLS = {
  options: new UrlPattern(`${API_V2_ADMIN_BASE}/assignment_types/options`),
  resource: new UrlPattern(`${API_V2_ADMIN_BASE}/assignment_types/:assignmentTypeId`),
  settings: new UrlPattern(`${API_V2_ADMIN_BASE}/assignment_types/settings`)
}

export const SUBMISSIONS_API_V2_URLS = {
  index: new UrlPattern(`${API_V2_STUDENT_BASE}/assignments/:assignmentId/submissions`),
  resource: new UrlPattern(`${API_V2_STUDENT_BASE}/assignments/:assignmentId/submissions/:submissionId`),
}

// Badges
export const BADGES_API_V2_URLS = {
  index: new UrlPattern(`${API_V2_ADMIN_BASE}/badges`),
  resource: new UrlPattern(`${API_V2_ADMIN_BASE}/badges/:badgeId`),
  reorder: new UrlPattern(`${API_V2_ADMIN_BASE}/badges/sort`),
  options: new UrlPattern(`${API_V2_ADMIN_BASE}/badges/options`),
  gradeOptions: new UrlPattern(`${API_V2_ADMIN_BASE}/badges/grade_options`)

};
export const STUDENT_BADGES_API_V2_URLS = {
  index: new UrlPattern(`${API_V2_STUDENT_BASE}/badges`),
  resource: new UrlPattern(`${API_V2_STUDENT_BASE}/badges/:badgeId`),
}

// Grade Scheme Elements (start for replacing what's used by gradeSchemeElements.js and pointsplanner.js)
export const GRADE_SCHEME_ELEMENTS_API_V2_URLS = {
  index: new UrlPattern(`${API_V2_STUDENT_BASE}/grade_scheme_elements`),
  staffIndex: new UrlPattern(`${API_V2_ADMIN_BASE}/grade_scheme_elements`),
  destroyAll: new UrlPattern(`${API_V2_ADMIN_BASE}/grade_scheme_elements/destroy_all`),
};

// Grades
export const GRADES_API_V2_URLS = {
  resource: new UrlPattern(`${API_V2_ADMIN_BASE}/grades/:gradeId`),
  groupResource: new UrlPattern(`${ASSIGNMENTS_API_V2_RESOURCE_URL}/groups/:groupId/grades`),
  quickGrade: new UrlPattern(`${ASSIGNMENTS_API_V2_RESOURCE_URL}/groups/quick_grade`),
  releaseGrades: new UrlPattern(`${API_V2_ADMIN_BASE}/grades/release_grades`),
}

// Jobs
const JOBS_BASE_API_V2_URL = `${API_V2_ADMIN_BASE}/jobs`;
const JOBS_RESOURCE_API_V2_URL = `${API_V2_ADMIN_BASE}/jobs/:jobId`;
export const JOBS_API_V2_URLS = {
  index: new UrlPattern(JOBS_BASE_API_V2_URL),
  resource: new UrlPattern(JOBS_RESOURCE_API_V2_URL),
  poll: new UrlPattern(`${JOBS_RESOURCE_API_V2_URL}/poll`),
}

// Learning Objectives
const LEARNING_OBJECTIVES_API_V2_ADMIN_BASE_URL = `${API_V2_ADMIN_BASE}/learning_objectives`;
const LEARNING_OBJECTIVES_API_V2_RESOURCE_URL = `${LEARNING_OBJECTIVES_API_V2_ADMIN_BASE_URL}/:learningObjectiveId`;
export const LEARNING_OBJECTIVES_API_V2_URLS = {
  index: new UrlPattern(LEARNING_OBJECTIVES_API_V2_ADMIN_BASE_URL),
  resource: new UrlPattern(LEARNING_OBJECTIVES_API_V2_RESOURCE_URL),
  options: new UrlPattern(`${LEARNING_OBJECTIVES_API_V2_ADMIN_BASE_URL}/options`),
  progress: new UrlPattern(`${LEARNING_OBJECTIVES_API_V2_RESOURCE_URL}/progress`),
  studentIndex: new UrlPattern(`${API_V2_STUDENT_BASE}/learning_objectives`),
  studentResource: new UrlPattern(`${API_V2_STUDENT_BASE}/learning_objectives/:learningObjectiveId`),
}

// Learning Objective Categories
const LEARNING_OBJECTIVE_CATEGORIES_API_V2_ADMIN_BASE_URL = `${API_V2_ADMIN_BASE}/learning_objective_categories`;
const LEARNING_OBJECTIVE_CATEGORIES_API_V2_RESOURCE_URL = `${LEARNING_OBJECTIVE_CATEGORIES_API_V2_ADMIN_BASE_URL}/:learningObjectiveCategoryId`;
export const LEARNING_OBJECTIVE_CATEGORIES_API_V2_URLS = {
  index: new UrlPattern(LEARNING_OBJECTIVE_CATEGORIES_API_V2_ADMIN_BASE_URL),
  resource: new UrlPattern(LEARNING_OBJECTIVE_CATEGORIES_API_V2_RESOURCE_URL),
  options: new UrlPattern(`${LEARNING_OBJECTIVE_CATEGORIES_API_V2_ADMIN_BASE_URL}/options`),
}

// Notifications
const NOTIFICATIONS_API_V2_RESOURCE_URL = `${API_V2_ADMIN_BASE}/notifications/:notificationId`;
export const NOTIFICATIONS_API_V2_URLS = {
  resource: new UrlPattern(NOTIFICATIONS_API_V2_RESOURCE_URL),
}

// Rubrics
const RUBRICS_API_V2_ADMIN_BASE_URL = `${API_V2_ADMIN_BASE}/rubrics`;
const RUBRICS_API_V2_RESOURCE_URL = `${RUBRICS_API_V2_ADMIN_BASE_URL}/:rubricId`;
export const RUBRICS_API_V2_URLS = {
  resource: new UrlPattern(RUBRICS_API_V2_RESOURCE_URL),
  options: new UrlPattern(`${RUBRICS_API_V2_ADMIN_BASE_URL}/options`),
  copy: new UrlPattern(`${RUBRICS_API_V2_ADMIN_BASE_URL}/copy`),
  v1CriteriaIndex: new UrlPattern('/api/criteria'),
  v1CriteriaResource: new UrlPattern('/api/criteria/:id')
}

// Teams
const TEAMS_API_V2_URL = `${API_V2_ADMIN_BASE}/teams`;

export const TEAMS_API_V2_URLS = {
  index: new UrlPattern(TEAMS_API_V2_URL),
  options: new UrlPattern(`${TEAMS_API_V2_URL}/options`),
}

// vue-store.js
export const userFlagAPIUrl = new UrlPattern("/users/:userId/flag");
export const courseStudentsAPIUrl = new UrlPattern("/api/courses/:courseId/students");
export const gradebookAssignmentsListAPIUrl = new UrlPattern("/api/gradebook/assignments");
export const gradebookStudentIdsAPIUrl = new UrlPattern("/api/gradebook/student_ids");
export const userDetailAPIUrl = new UrlPattern("/api/users/:userId");
export const toggleCourseMembershipStatusAPIUrl = new UrlPattern("/api/course_memberships/delete_course_membership");
export const toggleStudentActivationStatusAPIUrl = new UrlPattern("/api/course_memberships/toggle_course_membership_activation");

export const courseCopyUrl = new UrlPattern("/api/courses/copy");

export const providerImportFormActionUrl = new UrlPattern("/courses/:courseId/users/importers/:providerName/users/course/:providerCourseId/import");
export const assignmentProviderUploadSampleCSVUrl = new UrlPattern("/courses/:courseId/assignments/importers/:providerName/download.csv")
export const assignmentProviderUploadUrl = new UrlPattern("/api/v2/admin/courses/:courseId/assignments/importers/:providerName/upload");
export const assignmentProviderCSVImportUrl = new UrlPattern("/api/v2/admin/courses/:courseId/assignments/importers/:providerName/import");
export const assignmentProviderImportFormActionUrl = new UrlPattern("/courses/:courseId/assignments/importers/:providerName/courses/:providerCourseId/assignments/import");
export const providerAuthAPIUrl = new UrlPattern("/auth/:providerName");
export const providerCourseAssignmentListAPIUrl = new UrlPattern("/api/v2/admin/courses/:courseId/assignments/importers/:providerName/course/:providerCourseId/assignments");
export const providerCourseListAPIUrl = new UrlPattern("/api/courses/importers/:providerName/courses");
export const providerCourseUserListAPIUrl = new UrlPattern("/api/users/importers/:providerName/course/:providerCourseId/users");


// old services, from vueifying grade edit
export const gradeFileUploadAPIUrl = new UrlPattern(`${API_V1_BASE}/grades/:gradeId/file_uploads`)
export const gradeFileRemoveAPIUrl = new UrlPattern(`${API_V1_BASE}/file_uploads/:fileId`)
export const groupGradeFileUploadAPIUrl = new UrlPattern(`${API_V1_BASE}/assignments/:assignmentId/groups/:groupId/file_uploads`)
export const objectiveOutcomeAPIUrl = new UrlPattern(`/api/assignments/:assignmentId/students/:studentId/learning_objectives/:objectiveId/update_outcome`)
export const objectiveOutcomeGroupAPIUrl = new UrlPattern(`/api/assignments/:assignmentId/groups/:groupId/learning_objectives/:objectiveId/update_outcome`)
export const earnedBadgesAPIUrl = new UrlPattern(`/api/earned_badges`);
export const earnedBadgeUpdateAPIUrl = new UrlPattern(`/api/earned_badges/:earnedBadgeId`);
export const CRITERIA_API_V0_URLS = {
  studentUpdateFields:new UrlPattern(`/api/assignments/:assignmentId/students/:studentId/criteria/:criterionId/update_fields`),
  groupUpdateFields: new UrlPattern(`/api/assignments/:assignmentId/groups/:groupId/criteria/:criterionId/update_fields`)
}